import { injectIntl, IntlShape } from 'react-intl';
import { useEffect } from 'react';
import { get, isEmpty, isEqual } from 'lodash';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { BlobProvider } from '@react-pdf/renderer';
import AdultRegulationRecap from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/AdultVictimRegulation/index';
import MinorRegulationRecap from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/MinorVictimRegulation/index';
import { EXPAND_RISK } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/constants';
import RegulationInformation from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/RegulationInformationRecap';
import { numberWithCommas } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import Document from 'components/Document';
import SahamAccordion from 'components/SahamAccordion';
import SummarySheet from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/Sheets/SummarySheet';
import { AssignedLawyer } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/typings';
import { blobtoDataUrl } from 'containers/UploadDocumentsManager/utils';
import SahamLoader from 'containers/AppContainer/Loader';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import CdraSheet from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/Sheets/CdraSheet';
import { translationMessages } from 'containers/LanguageProvider/intl';
import {
  showCdraSheet,
  showCnraSheet,
  showSummarySheet,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/utils';
import CnraSheet from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/Sheets/CnraSheet';
import { ClaimRecapType } from 'typings/claimTypes';

const transMessages = translationMessages;

export interface CorpoRegulationRecapProps {
  intl: IntlShape;
  setRiskRecap: Function;
  riskRecap: any;
  listings: Listings;
  activeStep: number;
  setActiveStep: Function;
  rcCorporeal: any;
  corpoEncryptedDocuments: any[];
  substituteDocumentNature: SagisConfig[];
  corpoEncryptedDocumentsResult: any;
  expanded: any;
  handleChangeExpanded: Function;
  lossDate: any;
  showValidationButton: boolean;
  claimRecap: ClaimRecapType;
  judgementOnMerits: any;
  sagisClaim: any;
  setEncryptedDocumentsOfAdults: Function;
  setEncryptedDocumentsOfMinors: Function;
  encryptedDocumentsOfMinors: any;
  encryptedDocumentsOfAdults: any;
  assignedLawyers: AssignedLawyer[];
  setBase64Url: Function;
  base64Url: any;
  provisionInfo: any;
  setProvisionInfo: Function;
  hasJom: boolean;
  corpoRegulations: any;
  policyInfo: any;
  lastSagisClaim: any;
  showProvisionDialog: boolean;
  setErrorSummarySheet: Function;
  isBasicManagementRegulation?: boolean;
}

export const CorpoRegulationRecap: React.FC<CorpoRegulationRecapProps> = ({
  setRiskRecap,
  riskRecap,
  listings,
  setActiveStep,
  rcCorporeal,
  activeStep,
  corpoEncryptedDocuments = [],
  substituteDocumentNature,
  corpoEncryptedDocumentsResult,
  expanded,
  handleChangeExpanded,
  lossDate,
  claimRecap,
  sagisClaim,
  ...props
}): JSX.Element => {
  useEffect(() => {
    props.setEncryptedDocumentsOfMinors({
      newAmount: 0,
      totalAmount: get(
        corpoEncryptedDocumentsResult[0],
        'documentChiffreCorporel.CNRA.totalAmount',
      ),
      encryptedDocumentsOfMinors: get(
        corpoEncryptedDocumentsResult[0],
        'documentChiffreCorporel.documentHeader.victimsDetailModel',
        [],
      ).filter((item: any) => !isEqual(get(item, 'indemnityCNRA'), 0)),
    });
  }, [corpoEncryptedDocuments, corpoEncryptedDocumentsResult]);
  useEffect(() => {
    props.setEncryptedDocumentsOfAdults({
      newAmount: 0,
      totalAmount: get(
        corpoEncryptedDocumentsResult[0],
        'documentChiffreCorporel.directCompensation.totalAmount',
        '',
      ),

      encryptedDocumentsOfAdults: get(
        corpoEncryptedDocumentsResult[0],
        'documentChiffreCorporel.documentHeader.victimsDetailModel',
        [],
      ).filter((item: any) => isEqual(get(item, 'indemnityCNRA'), 0)),
    });
  }, [corpoEncryptedDocumentsResult, corpoEncryptedDocuments]);

  const handleChange = (
    encryptedDocument: any,
    setEncryptedDocument: Function,
  ) => (event: React.ChangeEvent<{ name?: string; value: any }>) => {
    setEncryptedDocument(
      Object.assign(
        {},
        {
          ...encryptedDocument,
        },
        { newAmount: numberWithCommas(event.target.value) },
      ),
    );
  };
  return (
    <main>
      <SahamAccordion
        key={rcCorporeal.regulationId}
        title={rcCorporeal.riskName}
        data-testId={'test_accordion'}
        expanded={get(expanded[rcCorporeal.regulationId], [EXPAND_RISK.SHOW])}
        onChange={handleChangeExpanded(rcCorporeal, [EXPAND_RISK.SHOW])}
      >
        <div>
          <RegulationInformation
            rcCorporeal={rcCorporeal}
            listings={listings}
            corpoEncryptedDocuments={corpoEncryptedDocuments}
            substituteDocumentNature={substituteDocumentNature}
            corpoEncryptedDocumentsResult={corpoEncryptedDocumentsResult}
            expanded={expanded}
            handleChangeExpanded={handleChangeExpanded}
            isBasicManagementRegulation={props.isBasicManagementRegulation}
          />
          {!isEmpty(
            get(
              props.encryptedDocumentsOfAdults,
              'encryptedDocumentsOfAdults',
              [],
            ),
          ) && (
            <AdultRegulationRecap
              rcCorporeal={rcCorporeal}
              listings={listings}
              encryptedDocumentsOfAdults={props.encryptedDocumentsOfAdults}
              setEncryptedDocumentsOfAdults={
                props.setEncryptedDocumentsOfAdults
              }
              corpoEncryptedDocuments={corpoEncryptedDocuments}
              substituteDocumentNature={substituteDocumentNature}
              corpoEncryptedDocumentsResult={corpoEncryptedDocumentsResult}
              expanded={expanded}
              handleChangeExpanded={handleChangeExpanded}
              handleChange={handleChange}
              lossDate={lossDate}
              regulations={get(sagisClaim, 'regulations', [])}
              corpoRegulations={props.corpoRegulations}
            />
          )}
          {!isEmpty(
            get(
              props.encryptedDocumentsOfMinors,
              'encryptedDocumentsOfMinors',
              [],
            ),
          ) && (
            <MinorRegulationRecap
              rcCorporeal={rcCorporeal}
              listings={listings}
              encryptedDocumentsOfMinors={props.encryptedDocumentsOfMinors}
              encryptedDocumentsOfAdults={props.encryptedDocumentsOfAdults}
              setEncryptedDocumentsOfMinors={
                props.setEncryptedDocumentsOfMinors
              }
              corpoEncryptedDocuments={corpoEncryptedDocuments}
              substituteDocumentNature={substituteDocumentNature}
              corpoEncryptedDocumentsResult={corpoEncryptedDocumentsResult}
              expanded={expanded}
              handleChangeExpanded={handleChangeExpanded}
              handleChange={handleChange}
              lossDate={lossDate}
              regulations={get(sagisClaim, 'regulations', [])}
              corpoRegulations={props.corpoRegulations}
            />
          )}
          <Document
            className={
              !showSummarySheet(
                props.showValidationButton,
                get(listings, 'PaymentMethod', []),
                rcCorporeal,
                props.showProvisionDialog,
              )
                ? ''
                : 'unshow-sheet'
            }
            name={'fiche_synthèse_brouillon'}
            type={'fiche_synthese_brouillon'}
            icon={
              <BlobProvider
                document={
                  <SummarySheet
                    intl={props.intl}
                    rcCorpo={rcCorporeal}
                    claimRecap={claimRecap}
                    judgementOnMerits={props.judgementOnMerits}
                    sagisClaim={sagisClaim}
                    corpoEncryptedDocumentsResult={
                      corpoEncryptedDocumentsResult
                    }
                    listings={listings}
                    assignedLawyers={props.assignedLawyers}
                    encryptedDocumentsOfMinors={
                      props.encryptedDocumentsOfMinors
                    }
                    encryptedDocumentsOfAdults={
                      props.encryptedDocumentsOfAdults
                    }
                    provisionInfo={props.provisionInfo}
                    setProvisionInfo={props.setProvisionInfo}
                    hasJom={props.hasJom}
                    corpoRegulations={props.corpoRegulations}
                    regulations={get(sagisClaim, 'regulations', [])}
                    lastSagisClaim={props.lastSagisClaim}
                    isDraft={true}
                  />
                }
              >
                {params => {
                  return (
                    <a
                      href={params.url ? params.url : ''}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <VisibilityIcon
                        style={{ color: 'black' }}
                        className="consult"
                      />
                    </a>
                  );
                }}
              </BlobProvider>
            }
          />
          <Document
            className={
              !showSummarySheet(
                props.showValidationButton,
                get(listings, 'PaymentMethod', []),
                rcCorporeal,
                props.showProvisionDialog,
              )
                ? 'unshow-sheet'
                : ''
            }
            name={'fiche_synthèse'}
            type={'fiche_synthese'}
            icon={
              <BlobProvider
                document={
                  <SummarySheet
                    intl={props.intl}
                    rcCorpo={rcCorporeal}
                    claimRecap={claimRecap}
                    judgementOnMerits={props.judgementOnMerits}
                    sagisClaim={sagisClaim}
                    corpoEncryptedDocumentsResult={
                      corpoEncryptedDocumentsResult
                    }
                    listings={listings}
                    assignedLawyers={props.assignedLawyers}
                    encryptedDocumentsOfMinors={
                      props.encryptedDocumentsOfMinors
                    }
                    encryptedDocumentsOfAdults={
                      props.encryptedDocumentsOfAdults
                    }
                    provisionInfo={props.provisionInfo}
                    setProvisionInfo={props.setProvisionInfo}
                    hasJom={props.hasJom}
                    corpoRegulations={props.corpoRegulations}
                    regulations={get(sagisClaim, 'regulations', [])}
                    lastSagisClaim={props.lastSagisClaim}
                    isDraft={false}
                  />
                }
              >
                {params => {
                  blobtoDataUrl(params?.blob).then((result: any) => {
                    if (!!result && result !== props.base64Url?.summarySheet) {
                      // Ensure result is different from the current summarySheet to avoid infinite loop
                      props.setBase64Url({
                        ...props.base64Url,
                        summarySheet: result,
                      });
                    }
                  });

                  get(params, 'error') && props.setErrorSummarySheet(true);

                  return (
                    <>
                      {get(params, 'loading', true) && !get(params, 'error') ? (
                        <SahamLoader withOpacity={false} />
                      ) : (
                        <a
                          href={params.url ? params.url : ''}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <VisibilityIcon
                            style={{ color: 'black' }}
                            className="consult"
                          />
                        </a>
                      )}
                    </>
                  );
                }}
              </BlobProvider>
            }
          />
          {showCdraSheet(
            rcCorporeal,
            sagisClaim,
            corpoEncryptedDocumentsResult,
          ) && (
            <Document
              name={'lettre_CDRA'}
              type={'lettre_CDRA'}
              icon={
                <BlobProvider
                  document={
                    <CdraSheet
                      intl={{
                        ...props.intl,
                        locale: 'ar',
                        messages: get(transMessages, 'ar'),
                      }}
                      rcCorpo={rcCorporeal}
                      claimRecap={claimRecap}
                      judgementOnMerits={props.judgementOnMerits}
                      sagisClaim={sagisClaim}
                      corpoEncryptedDocumentsResult={
                        corpoEncryptedDocumentsResult
                      }
                      listings={listings}
                      assignedLawyers={props.assignedLawyers}
                      encryptedDocumentsOfMinors={
                        props.encryptedDocumentsOfMinors
                      }
                      encryptedDocumentsOfAdults={
                        props.encryptedDocumentsOfAdults
                      }
                      provisionInfo={props.provisionInfo}
                      setProvisionInfo={props.setProvisionInfo}
                      hasJom={props.hasJom}
                      corpoRegulations={props.corpoRegulations}
                      regulations={get(sagisClaim, 'regulations', [])}
                      lossDate={lossDate}
                      policyInfo={props.policyInfo}
                    />
                  }
                >
                  {params => {
                    blobtoDataUrl(params?.blob).then((result: any) => {
                      if (!!result && result !== props.base64Url?.cdraSheet) {
                        // Ensure result is different from the current summarySheet to avoid infinite loop
                        props.setBase64Url({
                          ...props.base64Url,
                          cdraSheet: result,
                        });
                      }
                    });

                    return (
                      <>
                        {get(params, 'loading', true) &&
                        !get(params, 'error') ? (
                          <SahamLoader withOpacity={false} />
                        ) : (
                          <a
                            href={params.url ? params.url : ''}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <VisibilityIcon
                              style={{ color: 'black' }}
                              className="consult"
                            />
                          </a>
                        )}
                      </>
                    );
                  }}
                </BlobProvider>
              }
            />
          )}
          {showCnraSheet(
            rcCorporeal,
            sagisClaim,
            corpoEncryptedDocumentsResult,
          ) && (
            <Document
              name={'lettre_CNRA'}
              type={'lettre_CNRA'}
              icon={
                <BlobProvider
                  document={
                    <CnraSheet
                      intl={{
                        ...props.intl,
                        locale: 'ar',
                        messages: get(transMessages, 'ar'),
                      }}
                      rcCorpo={rcCorporeal}
                      claimRecap={claimRecap}
                      judgementOnMerits={props.judgementOnMerits}
                      sagisClaim={sagisClaim}
                      corpoEncryptedDocumentsResult={
                        corpoEncryptedDocumentsResult
                      }
                      listings={listings}
                      assignedLawyers={props.assignedLawyers}
                      encryptedDocumentsOfMinors={
                        props.encryptedDocumentsOfMinors
                      }
                      encryptedDocumentsOfAdults={
                        props.encryptedDocumentsOfAdults
                      }
                      provisionInfo={props.provisionInfo}
                      setProvisionInfo={props.setProvisionInfo}
                      hasJom={props.hasJom}
                      corpoRegulations={props.corpoRegulations}
                      regulations={get(sagisClaim, 'regulations', [])}
                      lossDate={lossDate}
                      policyInfo={props.policyInfo}
                    />
                  }
                >
                  {params => {
                    blobtoDataUrl(params?.blob).then((result: any) => {
                      if (!!result && result !== props.base64Url?.cnraSheet) {
                        // Ensure result is different from the current summarySheet to avoid infinite loop
                        props.setBase64Url({
                          ...props.base64Url,
                          cnraSheet: result,
                        });
                      }
                    });

                    return (
                      <>
                        {get(params, 'loading', true) &&
                        !get(params, 'error') ? (
                          <SahamLoader withOpacity={false} />
                        ) : (
                          <a
                            href={params.url ? params.url : ''}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <VisibilityIcon
                              style={{ color: 'black' }}
                              className="consult"
                            />
                          </a>
                        )}
                      </>
                    );
                  }}
                </BlobProvider>
              }
            />
          )}
        </div>
      </SahamAccordion>
    </main>
  );
};

export default injectIntl(CorpoRegulationRecap);
